import { Component, EventEmitter, Output, Input, OnInit, signal, WritableSignal, effect, runInInjectionContext , Injector  }  from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ChartModule } from 'primeng/chart';
import { Chart } from 'chart.js';
import {TableRow, TableColumn} from '../../../../../shared/models/components/tables/table.models';

@Component({
    selector: 'app-model-charts',
    imports: [CommonModule, DialogModule, ChartModule],
    templateUrl: './model-charts.component.html',
    styleUrl: './model-charts.component.scss'
})
export class ModelChartsComponent {
  @Output() close = new EventEmitter<void>();
  @Input() isVisible!: WritableSignal<boolean>;
  @Input() columnsResults!: WritableSignal<TableColumn[]>;
  @Input() rowsResults!: WritableSignal<TableRow[]>;

  // data: any;
  // options: any;
  lineChartData: any;
  barChartData: any;
  lineOptions: any;
  barOptions: any;

  colors: string[] = [
    '#faab18', '#00b2bd', '#009dd9', '#b2cc34', '#e21836', '#ba3093',
    '#e5601f', '#00708c', '#0066b2', '#769231', '#97002e', '#751269',
    '#711b00', '#003653', '#0b2d71', '#444b0d', '#58001c', '#3a0d36'
  ];


  constructor(private injector: Injector) {
    // Usar runInInjectionContext para ejecutar effect en el contexto adecuado
    runInInjectionContext(this.injector, () => {
      effect(() => {
        this.updateChartData();
      });
    });
  }

  ngOnInit() {

    this.updateChartData();

    this.lineOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom'
        },
        tooltip: {
          callbacks: {
            label: (context: any) => `${context.dataset.label}: ${this.formatDisplayValue(context.parsed?.y)}`
          }
        }
      },
      scales: {
        y: {
          ticks: {
            callback: (value: unknown) => this.formatDisplayValue(value)
          }
        }
      }
    };

    this.barOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom'
        },
        tooltip: {
          callbacks: {
            label: (context: any) => `${context.dataset.label}: ${this.formatDisplayValue(context.parsed?.y)}`
          }
        }
      },
      scales: {
        x: {
          stacked: false
        },
        y: {
          stacked: false,
          ticks: {
            callback: (value: unknown) => this.formatDisplayValue(value)
          }
        }
      },
      barThickness: 20 
    };

    // runInInjectionContext(() => {
    //   effect(() => {
    //     this.updateChartData();
    //   });
    // });
  }

  
  updateChartData() {
    this.lineChartData = {
      labels: this.getLabels(),
      datasets: this.getLineDatasets()
    };

    this.barChartData = {
      labels: this.getCaseLabels(),
      datasets: this.getBarDatasets()
    };
  }

  getLabels() {
    return this.rowsResults().map(row => row.field);
  }

  getLineDatasets() {
    const filteredColumns = this.columnsResults().slice(1);

    return filteredColumns.map((column, index) => ({
      label: column.header,
      data: this.rowsResults().map(row => this.convertToNumber(row[column.field])),
      borderColor:  this.colors[index % this.colors.length],
      fill: false
    }));
  }

  getCaseLabels() {
    return this.columnsResults().slice(1).map(column => column.header);
  }

  getBarDatasets() {
    const models = this.rowsResults().map(row => row.field);

    return models.map((model, index) => ({
      label: model,
      data: this.columnsResults().slice(1).map(column => this.convertToNumber(this.rowsResults()[index][column.field])),
      backgroundColor:this.colors[index % this.colors.length]
    }));
  }

  convertToNumber(value: string): number {
    const normalized = String(value).replace(/\$/g, '').replace(/,/g, '').trim();

    // Display-only normalization for scientific notation values from backend.
    // Example: 2.74931894e+211 -> 2.75 on charts.
    if (/[eE]/.test(normalized)) {
      const mantissa = parseFloat(normalized.split(/[eE]/)[0]);
      if (!Number.isFinite(mantissa)) {
        return 0;
      }
      return Number(mantissa.toFixed(2));
    }

    const parsed = parseFloat(normalized);
    if (!Number.isFinite(parsed)) {
      return 0;
    }

    return Number(parsed.toFixed(2));
  }

  private formatDisplayValue(value: unknown): string {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return '0.00';
    }

    return new Intl.NumberFormat('en-US', {
      notation: 'standard',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true
    }).format(numericValue);
  }

  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  onCloseModal() {
    this.isVisible.set(false);
    this.close.emit();
  }
}
